import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import RatingModalPage from '../../../containers/masters/Rating/RatingModalPage'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import InputDecimal from '../../commons/form/InputDecimal'

class RatingMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        name: null,
        description: null,
        import: null
      }
    }
  }

  componentDidUpdate () {
    if (this.props.ouIdFromMaster != null) {
      const form = {
        filters: {
          organizedUnitId: this.props.ouIdFromMaster
        }
      }
      this.props.initialize(form)
      this.handleorganizedUnitComboChange(this.props.ouIdFromMaster)
      this.props.actions.setChangeTabFromConfMaster(null, false)
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchRatingList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchRatingList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleorganizedUnitComboChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  handleNameChange (value) {
    this.setState({ filter: { ...this.state.filter, name: value } })
  }

  handleImportChange (value) {
    this.setState({ filter: { ...this.state.filter, import: value } })
  }

  handleDescriptionChange (value) {
    this.setState({ filter: { ...this.state.filter, description: value } })
  }

  search () {
    this.props.actions.fetchRatingList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        organizedUnitId: null,
        name: null,
        description: null,
        import: null
      }
    }, () => {
      this.search()
    })
  }

  render () {
    const {
      t, ratingList, pagesCount, ratingListCount, filter,
      combos: { organizedUnitsAllCombo },
      filter: { page },
      actions: { openRatingModal, fetchRatingList, deleteRating }
    } = this.props
    const tKey = 'MASTERS.RATING_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.organizedUnitId || this.state.filter.description || this.state.filter.name || this.state.filter.import)
    return (
      <div className="admin-wrapper">
        <RatingModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}RATING`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                name="filters.organizedUnitId"
                colSm={3}
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                component={InputSelect}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleorganizedUnitComboChange(value)}
              />
              <Field
                id="filters.name"
                name="filters.name"
                colSm={3}
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                component={InputText}
                onInputChange={(value) => this.handleNameChange(value)}
                maxLength={50}
              />
              <Field
                id="filters.description"
                name="filters.description"
                colSm={3}
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                component={InputText}
                onInputChange={(value) => this.handleDescriptionChange(value)}
                maxLength={50}
              />
              <Field
                id="filters.import"
                name="filters.import"
                colSm={3}
                controlLabel={t(`${tKey}IMPORT`)}
                placeholder={t(`${tKey}IMPORT`)}
                valueKey="id"
                labelKey="value"
                component={InputDecimal}
                onChange={(event, value) => this.handleImportChange(value)}
                maxLength={50}
              />
            </Row>
            <Row>
              <Col sm={3} className="btn-wrapper" >
                <Button
                  className={'btn-white btn-input2 btn-white search-button'}
                  style={{ width: '100%', marginTop: '23px' }}
                  onClick={() => this.search()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button style={{ marginTop: '23px' }}
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
            <br/>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                  {t(`${tKey}OU`)}
                  <i className={this.getSortIcon('organizedUnitId')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DESCRIPTION`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th onClick={() => { this.changeOrder('import') }}>
                  {t(`${tKey}IMPORT`)}
                  <i className={this.getSortIcon('import')} />
                </th>
                <th style={{ width: '77px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {ratingList && ratingList.map((rating, idx) => {
                return (
                  <tr key={idx} className={rating.isDeleted ? 'is-deleted' : ''}>
                    <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === rating?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === rating?.organizedUnitId).value}</td>
                    <td>{rating.name}</td>
                    <td>{rating.description}</td>
                    <td>{rating.import}€</td>
                    <td>
                      {!rating.isDeleted && (
                        <div>
                          <a onClick={() => openRatingModal(rating)}>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <i className="ico-edit-white" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => deleteRating(rating.ratingId)}>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <i className="ico-trash" />
                            </OverlayTrigger>
                          </a>
                        </div>
                      )}
                    </td>
                  </tr>)
              })
              }
              {(ratingList === null || ratingList === undefined || ratingList.length === 0) &&
            <tr>
              <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => openRatingModal()}>
                  + {t(`${tKey}ADD`)}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={ratingListCount}
                onSelectAction={(value) => fetchRatingList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'rating'
})(RatingMaster)
